import { Box, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import { METHOD_GET } from 'src/lib/constants/apis';
import { STRAPI_URL } from 'src/lib/constants/url';
import MarkdownRenderer from '../../../../../../../components/ui-component/markdown-renderer/MarkdownRenderer';

const AllgemeinHinweisGlobal: FC<{ eachHinweis: any; hinweisPath: any }> = ({ eachHinweis, hinweisPath }) => {
	return (
		<>
			<Box sx={{ mt: '1rem' }}>
				<Typography variant='h3' component={'h3'}>
					{get(eachHinweis, hinweisPath.Untertitel, '')}
				</Typography>
				<MarkdownRenderer markdown={get(eachHinweis, hinweisPath.Inhalte, '')} />

				<RenderImage bildPath={get(eachHinweis, hinweisPath.Bild)} />
			</Box>
		</>
	);
};
export default AllgemeinHinweisGlobal;

/**
 * ERSTMAL AUSGEBLENDET
 */
const RenderImage: FC<{ bildPath: string }> = ({ bildPath }) => {
	const bildUrl = get(bildPath, 'attributes.url', '');
	const [downloadedImageUrl, setDownloadedImageUrl] = useState<string | null>(null); // State to hold the image URL

	useEffect(() => {
		const fetchImage = async () => {
			try {
				const fileUrl = bildUrl.startsWith('/private/') ? `${STRAPI_URL}/api/files${bildUrl}` : `${STRAPI_URL}${bildUrl}`;
				const response = await fetch(fileUrl, {
					method: METHOD_GET,
					credentials: 'include',
				});

				if (!response.ok) {
					throw new Error('Failed to fetch the image');
				}

				const blob = await response.blob(); // Convert the response to a blob
				const imageObjectUrl = URL.createObjectURL(blob); // Create an object URL
				setDownloadedImageUrl(imageObjectUrl); // Set the URL to the state
			} catch (error) {
				console.error('Error fetching the image:', error);
			}
		};

		if (bildUrl) fetchImage(); // Fetch the image when the component mounts

		// Clean up the object URL to avoid memory leaks
		return () => {
			if (bildUrl) {
				URL.revokeObjectURL(bildUrl);
			}
		};
	}, [bildUrl]);

	if (bildUrl && downloadedImageUrl) {
		return <img src={downloadedImageUrl} alt='Allgemein Hinweis' width={800} />;
	}
	return <></>;
};
